<template>
  <div
    style="position: relative;"
    :style="{
      'padding-top': facade.padding_sx + 'px', 
      'padding-bottom': facade.padding_sx + 'px',
      'background-color': facade.background_style == 1 ? facade.background_color : '',
      'background-image': facade.background_style == 2 ? 'url(' + facade.background_url + ')' : '',
	  }"
  >
    <van-swipe
      :show-indicators="false"
      :autoplay="5000"
      :style="{height: bigHeight + 'px'}"
      @change="onChange"
    >
      <van-swipe-item
        v-for="(item, index) in content.data"
        :key="index"
        @click="goNext(item)"
      >
        <div style="position: relative;" :style="{paddingLeft: facade.padding_zy + 'px', paddingRight: facade.padding_zy + 'px'}">
          <img :src="item.url" :id="index" @load="imageLoad" :style="{borderRadius: facade.picture_radius + 'px'}" style="width: 100%;" />
        </div>
      </van-swipe-item>
    </van-swipe>
    <pointer
      :margin="facade.padding_zy + 12"
      :data="content.data"
      :index="curIndex"
      :color="facade.indicator_color"
      :type="facade.indicator_style"
      :align="facade.indicator_align"
    ></pointer>
  </div>
</template>

<script>
import pointer from './pointer.vue';

export default {
  components: {
    pointer
  },
  data() {
    return {
      imgheights: [],
      bigHeight: '',
      curIndex: 0,
      windowWidth: 390
    }
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth
  },
  methods: {
    goNext(item) {
      this.$emit('go-next', item.link)
    },
    onChange(e) {
      this.curIndex = e
    },
    imageLoad(e) { //当图片载入完毕时
      if (e.target) {
        var imgwidth = e.target.width,
          imgheight = e.target.height,
          ratio = imgwidth / imgheight; //宽高比

        let curWidth = this.windowWidth - ((this.facade && this.facade.padding_zy) || 0) * 2
        this.imgheights[e.target.id] = curWidth / ratio // 计算的高度值
        this.bigHeight = Math.max.apply(null, this.imgheights.map(item => item))
      }
      console.log('最大的图片高度：', this.bigHeight, this.imgheights)
    },
  }
}
</script>

<style>

</style>